import React from 'react';
import { motion } from 'framer-motion';
import { FaGraduationCap, FaUniversity, FaCalendarAlt } from 'react-icons/fa';
import AuroraBackground from './AuroraBackground';
import ParticleBackground from './ParticleBackground';
import portfolioData from '../data/portfolio.json';
import './Experience.css';

const Education = () => {
    const education = portfolioData.education;

    return (
        <div className="experience-page">
            <AuroraBackground />
            <ParticleBackground particleCount={25} />
            {/* EDUCATION SECTION */}
            <section className="education-section">
                <div className="section-background education-bg"></div>
                <div className="container">
                    <motion.div
                        className="section-header"
                        initial={{ opacity: 0, y: -30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >
                        <div className="section-icon-wrapper education-icon-wrapper">
                            <FaGraduationCap className="section-icon" />
                        </div>
                        <h1 className="section-main-title">Education</h1>
                        <p className="section-subtitle">Academic foundation and achievements</p>
                        <div className="title-underline education-underline"></div>
                    </motion.div>

                    <div className="education-timeline-wrapper">
                        <div className="timeline education-timeline">
                            {education.map((edu, index) => (
                                <motion.div
                                    key={edu.institution}
                                    className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
                                    initial={{ opacity: 0, y: 50, scale: 0.9 }}
                                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                                    viewport={{ once: true, margin: "-100px" }}
                                    transition={{
                                        duration: 0.6,
                                        delay: index * 0.15,
                                        type: "spring",
                                        stiffness: 100
                                    }}
                                    whileHover={{ scale: 1.02, y: -5 }}
                                >
                                    <div className="timeline-connector education-connector"></div>
                                    <div className="timeline-dot education-dot">
                                        <div className="dot-pulse"></div>
                                        <FaUniversity className="dot-icon" />
                                    </div>
                                    <motion.div
                                        className="timeline-card education-card"
                                        whileHover={{ boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)" }}
                                    >
                                        <div className="card-glow education-glow"></div>
                                        <div className="card-content">
                                            <div className="card-header">
                                                <h3 className="card-title">{edu.degree}</h3>
                                                <div className="card-badge education-badge">Education</div>
                                            </div>
                                            <h4 className="card-company">{edu.institution}</h4>
                                            <div className="card-duration">
                                                <FaCalendarAlt className="duration-icon" />
                                                <span>{edu.duration}</span>
                                            </div>
                                            {edu.description && (
                                                <p className="card-description">{edu.description}</p>
                                            )}
                                        </div>
                                    </motion.div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Education;

